import {Injectable} from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../auth';
import { Globals } from '../globals';
import { Observable } from 'rxjs';

export class Foo {
    constructor(
      public id: number,
      public name: string) { }
}

@Injectable()
export class HomeService {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    getResource(id) : Observable<Foo> {
        this.authService.isTokenValid();

        const url = this.authService.getResourceURL() + '/foos/';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get<Foo>(url+id, {headers: requestHeaders, responseType: 'json'})
    }
}
